import PageLayout from "../../components/common/page-layout";
import OutlookIntegrations from "../../components/doc-scanning/outlook-integrations/outlook-integrations";
import { RequireAuth } from "../../hooks/use-auth";

/**
 * Outlook mailbox integrations: the mailboxes documents arrive in, and the
 * outbound domains allowed to reply from them.
 */
const OutlookIntegrationsPage = () => {
  return (
    <RequireAuth>
      <PageLayout
        maxWidth={false}
        subtitle="Mailboxes that feed document ingestion"
        title="Outlook integrations"
      >
        <OutlookIntegrations />
      </PageLayout>
    </RequireAuth>
  );
};

export default OutlookIntegrationsPage;
